import { render, staticRenderFns } from "./industry-info.vue?vue&type=template&id=090f42f0&scoped=true&"
import script from "./industry-info.vue?vue&type=script&lang=js&"
export * from "./industry-info.vue?vue&type=script&lang=js&"
import style0 from "./industry-info.vue?vue&type=style&index=0&id=090f42f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f42f0",
  null
  
)

export default component.exports